import CommonService from './common.service'

import { _object } from 'utils/interfaces'
import { generateQueryParams } from 'utils'

class OrderService extends CommonService {
  async getOrders(params: _object) {
    return await this.get(`/orders/?${generateQueryParams(params)}`)
  }

  async getOrdersDetails(id: string | undefined) {
    return await this.get(`/orders/${id}`)
  }

  async getOrdersInvoiced(id: string | undefined) {
    return await this.get(`/orders/${id}/invoice`)
  }
}

export const orderService = new OrderService()
